import { createRoot } from 'react-dom/client'
import { Toast, ToastContainer, ThemeProvider } from '@mdsol/onex-design'
import React from 'react'

let toastId = 0

type ToastPosition = 'top-right' | 'bottom-right'

const showToast = (
  variant: 'success' | 'critical' | 'caution' | 'information',
  header: string,
  position: ToastPosition = 'top-right'
) => {
  const id = toastId++

  // Create a dedicated container for this toast
  const toastWrapper = document.createElement('div')
  toastWrapper.style.position = 'fixed'
  toastWrapper.style.right = '20px'
  toastWrapper.style.zIndex = '9999'
  if (position === 'bottom-right') {
    toastWrapper.style.bottom = '20px'
  } else {
    toastWrapper.style.top = '20px'
  }
  document.body.appendChild(toastWrapper)

  const root = createRoot(toastWrapper)

  const handleClose = () => {
    setTimeout(() => {
      root.unmount()
      toastWrapper.remove()
    }, 300)
  }

  root.render(
    <ThemeProvider>
      <ToastContainer position={position}>
        <Toast variant={variant} header={header} show={true} autohide={true} delay={4000} onClose={handleClose} />
      </ToastContainer>
    </ThemeProvider>
  )
}

export const toast = {
  success: (message: string, position?: ToastPosition) => showToast('success', message, position),
  error: (message: string, position?: ToastPosition) => showToast('critical', message, position),
  warning: (message: string, position?: ToastPosition) => showToast('caution', message, position),
  info: (message: string, position?: ToastPosition) => showToast('information', message, position)
}
